<template>
  <div id="projectIndex">
    <div class="formBody">
      <!-- 搜索行 -->
      <div class="searchRow">
        <el-input class="tableSearch" v-model="searchInfo" placeholder="搜索项目名称"></el-input>
        <el-select
          class="tableSearch"
          style="margin-left:2%"
          v-model="searchproject_type_id"
          clearable
          placeholder="搜索项目类型"
        >
          <el-option
            v-for="item in projectTypeList"
            :key="item.project_type_id"
            :label="item.project_type_name"
            :value="item.project_type_id"
          ></el-option>
        </el-select>
        <el-date-picker
          v-model="searchDate1"
          class="tableSearch"
          type="date"
          style="margin-right:0;margin-left:2%;"
          placeholder="开始时间"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptionsStart"
        ></el-date-picker>

        <span style="line-height:48px;margin:0 2%;color:#666">至</span>
        <el-date-picker
          class="tableSearch"
          style="margin-right:2%"
          v-model="searchDate2"
          type="date"
          placeholder="结束时间"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptionsEnd"
        ></el-date-picker>
        <one-selected class="tableSearch" @my-one-change="handleSearchPeopleChange"></one-selected>
        <div class="btnCol">
          <el-button @click="handleSearch" class="search">筛选</el-button>
          <el-button class="creat" @click="goAddProject" style="background-color:#40A0F2;">新增</el-button>
        </div>
      </div>
      <!-- tabs -->
      <el-tabs v-model="projectActive" @tab-click="handleClick">
        <!-- 全部 -->
        <el-tab-pane label="全部" name="1">
          <div class="knowledgeHisTable">
            <ul v-if="projectList.length>0" class="table__body">
              <li
                class="tableBodyItem"
                v-for="item in projectList"
                :key="item.project_id"
                @click="showDetails(item)"
              >
                <div class="itemleft">
                  <h3 class="projectItemTitle">
                    <span class="starIcon">
                      <i
                        v-if="item.is_attention==0"
                        class="el-icon-star-off"
                        @click.stop="handleCollect(item.project_id,'1')"
                        style="margin-right:10px;color:#AEB5BE"
                      ></i>
                      <i
                        class="el-icon-star-on"
                        v-if="item.is_attention==1"
                        @click.stop="handleCollect(item.project_id,'-1')"
                        style="margin-right:10px;color:#128bf1;font-size:24px"
                      ></i>
                    </span>
                    {{item.project_name}}
                  </h3>
                  <p style="margin-top:20px;display:flex;">
                    <span style="display:flex;">
                      <span>企业名称：</span>
                      <span
                        class="projectListOver"
                        :title="item.company_name"
                        style="color:#666"
                      >{{item.company_name}}</span>
                    </span>
                    <span style="margin-left:30px">
                      <span>项目阶段：</span>
                      <span style="color: #0099ff;">{{item.project_status_show}}</span>
                    </span>
                    <span style="margin-left:30px">
                      <span>项目编号：</span>
                      <span>{{item.project_code}}</span>
                    </span>
                  </p>
                  <p style="margin-top:15px;">
                    <span>
                      <span>项目类型：</span>
                      <span style="color:#666">{{item.project_type_show}}</span>
                    </span>
                    <span style="margin-left:30px">
                      <span v-if="item.memberInfo.nickname">项目登记人：</span>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        v-if="item.memberInfo"
                        :content="item.memberInfo.nickname"
                        placement="top"
                      >
                        <span
                          v-if="item.memberInfo"
                          style="color:#666;width:100px;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"
                        >{{item.memberInfo.nickname}}</span>
                      </el-tooltip>
                    </span>
                    <span v-if="item.evaluatorsInfo.nickname" style="margin-left:30px">
                      <span>项目主办：</span>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        v-if="item.evaluatorsInfo"
                        :content="item.evaluatorsInfo.nickname"
                        placement="top"
                      >
                        <span
                          v-if="item.evaluatorsInfo"
                          style="color:#666;width:100px;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"
                        >{{item.evaluatorsInfo.nickname}}</span>
                      </el-tooltip>
                    </span>
                    <span style="margin-left:30px">
                      <span>合同编号：</span>
                      <span style="color:#666">{{item.contract_code}}</span>
                    </span>
                    <span
                      v-if="item.is_draft=='1'"
                      style="color:rgb(245, 95, 95);margin-left:30px"
                    >草稿</span>
                  </p>
                </div>
                <div class="itemRight">
                  <!-- 上头像 -->
                  <div style="display:flex;justify-content: flex-end;">
                    <!-- <img class="headerLogo" src="../../assets/image/headerLogio.png" alt /> -->
                    <img
                      class="headerLogo"
                      v-if="item.memberInfo"
                      :src="item.memberInfo.avatar"
                      alt
                    />
                    <img
                      class="headerLogo"
                      v-if="item.evaluatorsInfo && item.evaluatorsInfo.avatar"
                      :src="item.evaluatorsInfo.avatar"
                      alt
                    />
                    <!-- 点击创建人显示信息 -->
                    <div class="moreDrop" style="width:46px;height:46px;margin-left: 10px;">
                      <img
                        @click.stop="activeDorpListClick(item.project_id)"
                        style="width:46px;height:46px;"
                        src="../../assets/image/morePeople.png"
                        alt
                      />
                      <div v-if="activeDorpList == item.project_id  " class="dropBody">
                        <p class="creatPeople">项目主办</p>
                        <div class="headerBox">
                          <div class="ceatPeopleInfo" v-for="item in listInfo1">
                            <!-- <img src="../../assets/image/headerLogio.png" alt /> -->
                            <img class="headerLogo" v-if="item.avatar" :src="item.avatar" alt />
                            <span v-if="item.nickname">{{item.nickname}}</span>
                          </div>
                        </div>
                        <p class="creatPeople">相关人员</p>
                        <div class="headerBox">
                          <!-- <div class="ceatPeopleInfo" v-for="item in 6">
                            <img src="../../assets/image/headerLogio.png" alt />
                            <span>张三三</span>
                          </div>-->
                          <div class="ceatPeopleInfo" v-for="item in listInfo2">
                            <img class="headerLogo" v-if="item.avatar" :src="item.avatar" alt />
                            <span v-if="item.nickname">{{item.nickname}}</span>
                          </div>
                        </div>
                        <div class="border-up-empty"></div>
                      </div>
                    </div>
                  </div>
                  <!-- 下按钮 -->
                  <el-button class="checkBtn" @click.stop="checkStepClick(item)">查看项目进度</el-button>
                  <el-button
                    class="checkBtn"
                    style="margin-top: 10px;"
                    @click.stop="handleTechAllocateClick(item)"
                  >技术人员分配</el-button>
                  <el-button
                    v-if="item.is_over=='1'"
                    class="checkBtn checkBtn1"
                    @click.stop="guidangClick(item)"
                  >归档项目</el-button>
                </div>
                <i
                  class="el-icon-close colseIcon"
                  @click.stop="handleRemoveProject(item.project_id)"
                ></i>
              </li>
            </ul>
            <div v-else class="emptyImg table__body">
              <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
            </div>
            <div class="pageRow" v-if="projectList.length>0">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 30]"
                :page-size="pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="Total"
              ></el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="立项" name="2">
          <div class="knowledgeHisTable">
            <ul v-if="projectList.length>0" class="table__body">
              <li
                class="tableBodyItem"
                v-for="item in projectList"
                :key="item.project_id"
                @click="showDetails(item)"
              >
                <div class="itemleft">
                  <h3 class="projectItemTitle">
                    <span class="starIcon">
                      <i
                        v-if="item.is_attention==0"
                        class="el-icon-star-off"
                        @click.stop="handleCollect(item.project_id,'1')"
                        style="margin-right:10px;color:#AEB5BE"
                      ></i>
                      <i
                        class="el-icon-star-on"
                        v-if="item.is_attention==1"
                        @click.stop="handleCollect(item.project_id,'-1')"
                        style="margin-right:10px;color:#128bf1;font-size:24px"
                      ></i>
                    </span>
                    {{item.project_name}}
                  </h3>
                  <p style="margin-top:20px;display:flex;">
                    <span style="display:flex;">
                      <span>企业名称：</span>
                      <span
                        class="projectListOver"
                        :title="item.company_name"
                        style="color:#666"
                      >{{item.company_name}}</span>
                    </span>
                    <span style="margin-left:30px">
                      <span>项目阶段：</span>
                      <span style="color: #0099ff;">{{item.project_status_show}}</span>
                    </span>
                    <span style="margin-left:30px">
                      <span>项目编号：</span>
                      <span>{{item.project_code}}</span>
                    </span>
                  </p>
                  <p style="margin-top:15px;">
                    <span>
                      <span>项目类型：</span>
                      <span style="color:#666">{{item.project_type_show}}</span>
                    </span>
                    <span style="margin-left:30px">
                      <span v-if="item.memberInfo.nickname">项目登记人：</span>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        v-if="item.memberInfo"
                        :content="item.memberInfo.nickname"
                        placement="top"
                      >
                        <span
                          v-if="item.memberInfo"
                          style="color:#666;width:100px;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"
                        >{{item.memberInfo.nickname}}</span>
                      </el-tooltip>
                    </span>
                    <span v-if="item.evaluatorsInfo.nickname" style="margin-left:30px">
                      <span>项目主办：</span>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        v-if="item.evaluatorsInfo"
                        :content="item.evaluatorsInfo.nickname"
                        placement="top"
                      >
                        <span
                          v-if="item.evaluatorsInfo"
                          style="color:#666;width:100px;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"
                        >{{item.evaluatorsInfo.nickname}}</span>
                      </el-tooltip>
                    </span>
                    <span style="margin-left:30px">
                      <span>合同编号：</span>
                      <span style="color:#666">{{item.contract_code}}</span>
                    </span>
                    <span
                      v-if="item.is_draft=='1'"
                      style="color:rgb(245, 95, 95);margin-left:30px"
                    >草稿</span>
                  </p>
                </div>
                <div class="itemRight">
                  <!-- 上头像 -->
                  <div style="display:flex;justify-content: flex-end;">
                    <!-- <img class="headerLogo" src="../../assets/image/headerLogio.png" alt /> -->
                    <img
                      class="headerLogo"
                      v-if="item.memberInfo"
                      :src="item.memberInfo.avatar"
                      alt
                    />
                    <img
                      class="headerLogo"
                      v-if="item.evaluatorsInfo && item.evaluatorsInfo.avatar"
                      :src="item.evaluatorsInfo.avatar"
                      alt
                    />
                    <!-- 点击创建人显示信息 -->
                    <div class="moreDrop" style="width:46px;height:46px;margin-left: 10px;">
                      <img
                        @click.stop="activeDorpListClick(item.project_id)"
                        style="width:46px;height:46px;"
                        src="../../assets/image/morePeople.png"
                        alt
                      />
                      <div v-if="activeDorpList == item.project_id  " class="dropBody">
                        <p class="creatPeople">项目主办</p>
                        <div class="headerBox">
                          <div class="ceatPeopleInfo" v-for="item in listInfo1">
                            <!-- <img src="../../assets/image/headerLogio.png" alt /> -->
                            <img class="headerLogo" v-if="item.avatar" :src="item.avatar" alt />
                            <span v-if="item.nickname">{{item.nickname}}</span>
                          </div>
                        </div>
                        <p class="creatPeople">相关人员</p>
                        <div class="headerBox">
                          <!-- <div class="ceatPeopleInfo" v-for="item in 6">
                            <img src="../../assets/image/headerLogio.png" alt />
                            <span>张三三</span>
                          </div>-->
                          <div class="ceatPeopleInfo" v-for="item in listInfo2">
                            <img class="headerLogo" v-if="item.avatar" :src="item.avatar" alt />
                            <span v-if="item.nickname">{{item.nickname}}</span>
                          </div>
                        </div>
                        <div class="border-up-empty"></div>
                      </div>
                    </div>
                  </div>
                  <!-- 下按钮 -->
                  <el-button class="checkBtn" @click.stop="checkStepClick(item)">查看项目进度</el-button>
                  <el-button
                    class="checkBtn"
                    style="margin-top: 10px;"
                    @click.stop="handleTechAllocateClick(item)"
                  >技术人员分配</el-button>
                  <el-button
                    v-if="item.is_over=='1'"
                    class="checkBtn checkBtn1"
                    @click.stop="guidangClick(item)"
                  >归档项目</el-button>
                </div>
                <i
                  class="el-icon-close colseIcon"
                  @click.stop="handleRemoveProject(item.project_id)"
                ></i>
              </li>
            </ul>
            <div v-else class="emptyImg table__body">
              <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
            </div>
            <div class="pageRow" v-if="projectList.length>0">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 30]"
                :page-size="pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="Total"
              ></el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="现场调查" name="3">
          <div class="knowledgeHisTable">
            <ul v-if="projectList.length>0" class="table__body">
              <li
                class="tableBodyItem"
                v-for="item in projectList"
                :key="item.project_id"
                @click="showDetails(item)"
              >
                <div class="itemleft">
                  <h3 class="projectItemTitle">
                    <span class="starIcon">
                      <i
                        v-if="item.is_attention==0"
                        class="el-icon-star-off"
                        @click.stop="handleCollect(item.project_id,'1')"
                        style="margin-right:10px;color:#AEB5BE"
                      ></i>
                      <i
                        class="el-icon-star-on"
                        v-if="item.is_attention==1"
                        @click.stop="handleCollect(item.project_id,'-1')"
                        style="margin-right:10px;color:#128bf1;font-size:24px"
                      ></i>
                    </span>
                    {{item.project_name}}
                  </h3>
                  <p style="margin-top:20px;display:flex;">
                    <span style="display:flex;">
                      <span>企业名称：</span>
                      <span
                        class="projectListOver"
                        :title="item.company_name"
                        style="color:#666"
                      >{{item.company_name}}</span>
                    </span>
                    <span style="margin-left:30px">
                      <span>项目阶段：</span>
                      <span style="color: #0099ff;">{{item.project_status_show}}</span>
                    </span>
                    <span style="margin-left:30px">
                      <span>项目编号：</span>
                      <span>{{item.project_code}}</span>
                    </span>
                  </p>
                  <p style="margin-top:15px;">
                    <span>
                      <span>项目类型：</span>
                      <span style="color:#666">{{item.project_type_show}}</span>
                    </span>
                    <span style="margin-left:30px">
                      <span v-if="item.memberInfo.nickname">项目登记人：</span>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        v-if="item.memberInfo"
                        :content="item.memberInfo.nickname"
                        placement="top"
                      >
                        <span
                          v-if="item.memberInfo"
                          style="color:#666;width:100px;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"
                        >{{item.memberInfo.nickname}}</span>
                      </el-tooltip>
                    </span>
                    <span v-if="item.evaluatorsInfo.nickname" style="margin-left:30px">
                      <span>项目主办：</span>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        v-if="item.evaluatorsInfo"
                        :content="item.evaluatorsInfo.nickname"
                        placement="top"
                      >
                        <span
                          v-if="item.evaluatorsInfo"
                          style="color:#666;width:100px;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"
                        >{{item.evaluatorsInfo.nickname}}</span>
                      </el-tooltip>
                    </span>
                    <span style="margin-left:30px">
                      <span>合同编号：</span>
                      <span style="color:#666">{{item.contract_code}}</span>
                    </span>
                    <span
                      v-if="item.is_draft=='1'"
                      style="color:rgb(245, 95, 95);margin-left:30px"
                    >草稿</span>
                  </p>
                </div>
                <div class="itemRight">
                  <!-- 上头像 -->
                  <div style="display:flex;justify-content: flex-end;">
                    <!-- <img class="headerLogo" src="../../assets/image/headerLogio.png" alt /> -->
                    <img
                      class="headerLogo"
                      v-if="item.memberInfo"
                      :src="item.memberInfo.avatar"
                      alt
                    />
                    <img
                      class="headerLogo"
                      v-if="item.evaluatorsInfo && item.evaluatorsInfo.avatar"
                      :src="item.evaluatorsInfo.avatar"
                      alt
                    />
                    <!-- 点击创建人显示信息 -->
                    <div class="moreDrop" style="width:46px;height:46px;margin-left: 10px;">
                      <img
                        @click.stop="activeDorpListClick(item.project_id)"
                        style="width:46px;height:46px;"
                        src="../../assets/image/morePeople.png"
                        alt
                      />
                      <div v-if="activeDorpList == item.project_id  " class="dropBody">
                        <p class="creatPeople">项目主办</p>
                        <div class="headerBox">
                          <div class="ceatPeopleInfo" v-for="item in listInfo1">
                            <!-- <img src="../../assets/image/headerLogio.png" alt /> -->
                            <img class="headerLogo" v-if="item.avatar" :src="item.avatar" alt />
                            <span v-if="item.nickname">{{item.nickname}}</span>
                          </div>
                        </div>
                        <p class="creatPeople">相关人员</p>
                        <div class="headerBox">
                          <!-- <div class="ceatPeopleInfo" v-for="item in 6">
                            <img src="../../assets/image/headerLogio.png" alt />
                            <span>张三三</span>
                          </div>-->
                          <div class="ceatPeopleInfo" v-for="item in listInfo2">
                            <img class="headerLogo" v-if="item.avatar" :src="item.avatar" alt />
                            <span v-if="item.nickname">{{item.nickname}}</span>
                          </div>
                        </div>
                        <div class="border-up-empty"></div>
                      </div>
                    </div>
                  </div>
                  <!-- 下按钮 -->
                  <el-button class="checkBtn" @click.stop="checkStepClick(item)">查看项目进度</el-button>
                  <el-button
                    class="checkBtn"
                    style="margin-top: 10px;"
                    @click.stop="handleTechAllocateClick(item)"
                  >技术人员分配</el-button>

                  <el-button
                    v-if="item.is_over=='1'"
                    class="checkBtn checkBtn1"
                    @click.stop="guidangClick(item)"
                  >归档项目</el-button>
                </div>
                <i
                  class="el-icon-close colseIcon"
                  @click.stop="handleRemoveProject(item.project_id)"
                ></i>
              </li>
            </ul>
            <div v-else class="emptyImg table__body">
              <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
            </div>
            <div class="pageRow" v-if="projectList.length>0">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 30]"
                :page-size="pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="Total"
              ></el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="三级审核" name="4">
          <div class="knowledgeHisTable">
            <ul v-if="projectList.length>0" class="table__body">
              <li
                class="tableBodyItem"
                v-for="item in projectList"
                :key="item.project_id"
                @click="showDetails(item)"
              >
                <div class="itemleft">
                  <h3 class="projectItemTitle">
                    <span class="starIcon">
                      <i
                        v-if="item.is_attention==0"
                        class="el-icon-star-off"
                        @click.stop="handleCollect(item.project_id,'1')"
                        style="margin-right:10px;color:#AEB5BE"
                      ></i>
                      <i
                        class="el-icon-star-on"
                        v-if="item.is_attention==1"
                        @click.stop="handleCollect(item.project_id,'-1')"
                        style="margin-right:10px;color:#128bf1;font-size:24px"
                      ></i>
                    </span>
                    {{item.project_name}}
                  </h3>
                  <p style="margin-top:20px;display:flex;">
                    <span style="display:flex;">
                      <span>企业名称：</span>
                      <span
                        class="projectListOver"
                        :title="item.company_name"
                        style="color:#666"
                      >{{item.company_name}}</span>
                    </span>
                    <span style="margin-left:30px">
                      <span>项目阶段：</span>
                      <span style="color: #0099ff;">{{item.project_status_show}}</span>
                    </span>
                    <span style="margin-left:30px">
                      <span>项目编号：</span>
                      <span>{{item.project_code}}</span>
                    </span>
                  </p>
                  <p style="margin-top:15px;">
                    <span>
                      <span>项目类型：</span>
                      <span style="color:#666">{{item.project_type_show}}</span>
                    </span>
                    <span style="margin-left:30px">
                      <span v-if="item.memberInfo.nickname">项目登记人：</span>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        v-if="item.memberInfo"
                        :content="item.memberInfo.nickname"
                        placement="top"
                      >
                        <span
                          v-if="item.memberInfo"
                          style="color:#666;width:100px;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"
                        >{{item.memberInfo.nickname}}</span>
                      </el-tooltip>
                    </span>
                    <span v-if="item.evaluatorsInfo.nickname" style="margin-left:30px">
                      <span>项目主办：</span>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        v-if="item.evaluatorsInfo"
                        :content="item.evaluatorsInfo.nickname"
                        placement="top"
                      >
                        <span
                          v-if="item.evaluatorsInfo"
                          style="color:#666;width:100px;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"
                        >{{item.evaluatorsInfo.nickname}}</span>
                      </el-tooltip>
                    </span>
                    <span style="margin-left:30px">
                      <span>合同编号：</span>
                      <span style="color:#666">{{item.contract_code}}</span>
                    </span>
                    <span
                      v-if="item.is_draft=='1'"
                      style="color:rgb(245, 95, 95);margin-left:30px"
                    >草稿</span>
                  </p>
                </div>
                <div class="itemRight">
                  <!-- 上头像 -->
                  <div style="display:flex;justify-content: flex-end;">
                    <!-- <img class="headerLogo" src="../../assets/image/headerLogio.png" alt /> -->
                    <img
                      class="headerLogo"
                      v-if="item.memberInfo"
                      :src="item.memberInfo.avatar"
                      alt
                    />
                    <img
                      class="headerLogo"
                      v-if="item.evaluatorsInfo && item.evaluatorsInfo.avatar"
                      :src="item.evaluatorsInfo.avatar"
                      alt
                    />
                    <!-- 点击创建人显示信息 -->
                    <div class="moreDrop" style="width:46px;height:46px;margin-left: 10px;">
                      <img
                        @click.stop="activeDorpListClick(item.project_id)"
                        style="width:46px;height:46px;"
                        src="../../assets/image/morePeople.png"
                        alt
                      />
                      <div v-if="activeDorpList == item.project_id  " class="dropBody">
                        <p class="creatPeople">项目主办</p>
                        <div class="headerBox">
                          <div class="ceatPeopleInfo" v-for="item in listInfo1">
                            <!-- <img src="../../assets/image/headerLogio.png" alt /> -->
                            <img class="headerLogo" v-if="item.avatar" :src="item.avatar" alt />
                            <span v-if="item.nickname">{{item.nickname}}</span>
                          </div>
                        </div>
                        <p class="creatPeople">相关人员</p>
                        <div class="headerBox">
                          <!-- <div class="ceatPeopleInfo" v-for="item in 6">
                            <img src="../../assets/image/headerLogio.png" alt />
                            <span>张三三</span>
                          </div>-->
                          <div class="ceatPeopleInfo" v-for="item in listInfo2">
                            <img class="headerLogo" v-if="item.avatar" :src="item.avatar" alt />
                            <span v-if="item.nickname">{{item.nickname}}</span>
                          </div>
                        </div>
                        <div class="border-up-empty"></div>
                      </div>
                    </div>
                  </div>
                  <!-- 下按钮 -->
                  <el-button class="checkBtn" @click.stop="checkStepClick(item)">查看项目进度</el-button>
                  <el-button
                    class="checkBtn"
                    style="margin-top: 10px;"
                    @click.stop="handleTechAllocateClick(item)"
                  >技术人员分配</el-button>
                  <el-button
                    v-if="item.is_over=='1'"
                    class="checkBtn checkBtn1"
                    @click.stop="guidangClick(item)"
                  >归档项目</el-button>
                </div>
                <i
                  class="el-icon-close colseIcon"
                  @click.stop="handleRemoveProject(item.project_id)"
                ></i>
              </li>
            </ul>
            <div v-else class="emptyImg table__body">
              <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
            </div>
            <div class="pageRow" v-if="projectList.length>0">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 30]"
                :page-size="pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="Total"
              ></el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="报告盖章" name="5">
          <div class="knowledgeHisTable">
            <ul v-if="projectList.length>0" class="table__body">
              <li
                class="tableBodyItem"
                v-for="item in projectList"
                :key="item.project_id"
                @click="showDetails(item)"
              >
                <div class="itemleft">
                  <h3 class="projectItemTitle">
                    <span class="starIcon">
                      <i
                        v-if="item.is_attention==0"
                        class="el-icon-star-off"
                        @click.stop="handleCollect(item.project_id,'1')"
                        style="margin-right:10px;color:#AEB5BE"
                      ></i>
                      <i
                        class="el-icon-star-on"
                        v-if="item.is_attention==1"
                        @click.stop="handleCollect(item.project_id,'-1')"
                        style="margin-right:10px;color:#128bf1;font-size:24px"
                      ></i>
                    </span>
                    {{item.project_name}}
                  </h3>
                  <p style="margin-top:20px;display:flex;">
                    <span style="display:flex;">
                      <span>企业名称：</span>
                      <span
                        class="projectListOver"
                        :title="item.company_name"
                        style="color:#666"
                      >{{item.company_name}}</span>
                    </span>
                    <span style="margin-left:30px">
                      <span>项目阶段：</span>
                      <span style="color: #0099ff;">{{item.project_status_show}}</span>
                    </span>
                    <span style="margin-left:30px">
                      <span>项目编号：</span>
                      <span>{{item.project_code}}</span>
                    </span>
                  </p>
                  <p style="margin-top:15px;">
                    <span>
                      <span>项目类型：</span>
                      <span style="color:#666">{{item.project_type_show}}</span>
                    </span>
                    <span style="margin-left:30px">
                      <span v-if="item.memberInfo.nickname">项目登记人：</span>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        v-if="item.memberInfo"
                        :content="item.memberInfo.nickname"
                        placement="top"
                      >
                        <span
                          v-if="item.memberInfo"
                          style="color:#666;width:100px;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"
                        >{{item.memberInfo.nickname}}</span>
                      </el-tooltip>
                    </span>
                    <span v-if="item.evaluatorsInfo.nickname" style="margin-left:30px">
                      <span>项目主办：</span>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        v-if="item.evaluatorsInfo"
                        :content="item.evaluatorsInfo.nickname"
                        placement="top"
                      >
                        <span
                          v-if="item.evaluatorsInfo"
                          style="color:#666;width:100px;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"
                        >{{item.evaluatorsInfo.nickname}}</span>
                      </el-tooltip>
                    </span>
                    <span style="margin-left:30px">
                      <span>合同编号：</span>
                      <span style="color:#666">{{item.contract_code}}</span>
                    </span>
                    <span
                      v-if="item.is_draft=='1'"
                      style="color:rgb(245, 95, 95);margin-left:30px"
                    >草稿</span>
                  </p>
                </div>
                <div class="itemRight">
                  <!-- 上头像 -->
                  <div style="display:flex;justify-content: flex-end;">
                    <!-- <img class="headerLogo" src="../../assets/image/headerLogio.png" alt /> -->
                    <img
                      class="headerLogo"
                      v-if="item.memberInfo"
                      :src="item.memberInfo.avatar"
                      alt
                    />
                    <img
                      class="headerLogo"
                      v-if="item.evaluatorsInfo && item.evaluatorsInfo.avatar"
                      :src="item.evaluatorsInfo.avatar"
                      alt
                    />
                    <!-- 点击创建人显示信息 -->
                    <div class="moreDrop" style="width:46px;height:46px;margin-left: 10px;">
                      <img
                        @click.stop="activeDorpListClick(item.project_id)"
                        style="width:46px;height:46px;"
                        src="../../assets/image/morePeople.png"
                        alt
                      />
                      <div v-if="activeDorpList == item.project_id  " class="dropBody">
                        <p class="creatPeople">项目主办</p>
                        <div class="headerBox">
                          <div class="ceatPeopleInfo" v-for="item in listInfo1">
                            <!-- <img src="../../assets/image/headerLogio.png" alt /> -->
                            <img class="headerLogo" v-if="item.avatar" :src="item.avatar" alt />
                            <span v-if="item.nickname">{{item.nickname}}</span>
                          </div>
                        </div>
                        <p class="creatPeople">相关人员</p>
                        <div class="headerBox">
                          <!-- <div class="ceatPeopleInfo" v-for="item in 6">
                            <img src="../../assets/image/headerLogio.png" alt />
                            <span>张三三</span>
                          </div>-->
                          <div class="ceatPeopleInfo" v-for="item in listInfo2">
                            <img class="headerLogo" v-if="item.avatar" :src="item.avatar" alt />
                            <span v-if="item.nickname">{{item.nickname}}</span>
                          </div>
                        </div>
                        <div class="border-up-empty"></div>
                      </div>
                    </div>
                  </div>
                  <!-- 下按钮 -->
                  <el-button class="checkBtn" @click.stop="checkStepClick(item)">查看项目进度</el-button>
                  <el-button
                    class="checkBtn"
                    style="margin-top: 10px;"
                    @click.stop="handleTechAllocateClick(item)"
                  >技术人员分配</el-button>
                  <el-button
                    v-if="item.is_over=='1'"
                    class="checkBtn checkBtn1"
                    @click.stop="guidangClick(item)"
                  >归档项目</el-button>
                </div>
                <i
                  class="el-icon-close colseIcon"
                  @click.stop="handleRemoveProject(item.project_id)"
                ></i>
              </li>
            </ul>
            <div v-else class="emptyImg table__body">
              <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
            </div>
            <div class="pageRow" v-if="projectList.length>0">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 30]"
                :page-size="pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="Total"
              ></el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="存档" name="6">
          <div class="knowledgeHisTable">
            <ul v-if="projectList.length>0" class="table__body">
              <li
                class="tableBodyItem"
                v-for="item in projectList"
                :key="item.project_id"
                @click="showDetails(item)"
              >
                <div class="itemleft">
                  <h3 class="projectItemTitle">
                    <span class="starIcon">
                      <i
                        v-if="item.is_attention==0"
                        class="el-icon-star-off"
                        @click.stop="handleCollect(item.project_id,'1')"
                        style="margin-right:10px;color:#AEB5BE"
                      ></i>
                      <i
                        class="el-icon-star-on"
                        v-if="item.is_attention==1"
                        @click.stop="handleCollect(item.project_id,'-1')"
                        style="margin-right:10px;color:#128bf1;font-size:24px"
                      ></i>
                    </span>
                    {{item.project_name}}
                  </h3>
                  <p style="margin-top:20px;display:flex;">
                    <span style="display:flex;">
                      <span>企业名称：</span>
                      <span
                        class="projectListOver"
                        :title="item.company_name"
                        style="color:#666"
                      >{{item.company_name}}</span>
                    </span>
                    <span style="margin-left:30px">
                      <span>项目阶段：</span>
                      <span style="color: #0099ff;">{{item.project_status_show}}</span>
                    </span>
                    <span style="margin-left:30px">
                      <span>项目编号：</span>
                      <span>{{item.project_code}}</span>
                    </span>
                  </p>
                  <p style="margin-top:15px;">
                    <span>
                      <span>项目类型：</span>
                      <span style="color:#666">{{item.project_type_show}}</span>
                    </span>
                    <span style="margin-left:30px">
                      <span v-if="item.memberInfo.nickname">项目登记人：</span>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        v-if="item.memberInfo"
                        :content="item.memberInfo.nickname"
                        placement="top"
                      >
                        <span
                          v-if="item.memberInfo"
                          style="color:#666;width:100px;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"
                        >{{item.memberInfo.nickname}}</span>
                      </el-tooltip>
                    </span>
                    <span v-if="item.evaluatorsInfo.nickname" style="margin-left:30px">
                      <span>项目主办：</span>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        v-if="item.evaluatorsInfo"
                        :content="item.evaluatorsInfo.nickname"
                        placement="top"
                      >
                        <span
                          v-if="item.evaluatorsInfo"
                          style="color:#666;width:100px;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"
                        >{{item.evaluatorsInfo.nickname}}</span>
                      </el-tooltip>
                    </span>
                    <span style="margin-left:30px">
                      <span>合同编号：</span>
                      <span style="color:#666">{{item.contract_code}}</span>
                    </span>
                    <span
                      v-if="item.is_draft=='1'"
                      style="color:rgb(245, 95, 95);margin-left:30px"
                    >草稿</span>
                  </p>
                </div>
                <div class="itemRight">
                  <!-- 上头像 -->
                  <div style="display:flex;justify-content: flex-end;">
                    <!-- <img class="headerLogo" src="../../assets/image/headerLogio.png" alt /> -->
                    <img
                      class="headerLogo"
                      v-if="item.memberInfo"
                      :src="item.memberInfo.avatar"
                      alt
                    />
                    <img
                      class="headerLogo"
                      v-if="item.evaluatorsInfo && item.evaluatorsInfo.avatar"
                      :src="item.evaluatorsInfo.avatar"
                      alt
                    />
                    <!-- 点击创建人显示信息 -->
                    <div class="moreDrop" style="width:46px;height:46px;margin-left: 10px;">
                      <img
                        @click.stop="activeDorpListClick(item.project_id)"
                        style="width:46px;height:46px;"
                        src="../../assets/image/morePeople.png"
                        alt
                      />
                      <div v-if="activeDorpList == item.project_id  " class="dropBody">
                        <p class="creatPeople">项目主办</p>
                        <div class="headerBox">
                          <div class="ceatPeopleInfo" v-for="item in listInfo1">
                            <!-- <img src="../../assets/image/headerLogio.png" alt /> -->
                            <img class="headerLogo" v-if="item.avatar" :src="item.avatar" alt />
                            <span v-if="item.nickname">{{item.nickname}}</span>
                          </div>
                        </div>
                        <p class="creatPeople">相关人员</p>
                        <div class="headerBox">
                          <!-- <div class="ceatPeopleInfo" v-for="item in 6">
                            <img src="../../assets/image/headerLogio.png" alt />
                            <span>张三三</span>
                          </div>-->
                          <div class="ceatPeopleInfo" v-for="item in listInfo2">
                            <img class="headerLogo" v-if="item.avatar" :src="item.avatar" alt />
                            <span v-if="item.nickname">{{item.nickname}}</span>
                          </div>
                        </div>
                        <div class="border-up-empty"></div>
                      </div>
                    </div>
                  </div>
                  <!-- 下按钮 -->
                  <el-button class="checkBtn" @click.stop="checkStepClick(item)">查看项目进度</el-button>
                  <el-button
                    class="checkBtn"
                    style="margin-top: 10px;"
                    @click.stop="handleTechAllocateClick(item)"
                  >技术人员分配</el-button>
                  <el-button
                    v-if="item.is_over=='1'"
                    class="checkBtn checkBtn1"
                    @click.stop="guidangClick(item)"
                  >归档项目</el-button>
                </div>
                <i
                  class="el-icon-close colseIcon"
                  @click.stop="handleRemoveProject(item.project_id)"
                ></i>
              </li>
            </ul>
            <div v-else class="emptyImg table__body">
              <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
            </div>
            <div class="pageRow" v-if="projectList.length>0">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 30]"
                :page-size="pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="Total"
              ></el-pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <check-step ref="checkStep"></check-step>

    <!-- 技术人员分配弹窗 -->
    <el-dialog
      title="技术人员分配"
      :visible.sync="techAllocateDialogVisible"
      width="50%"
      :before-close="handleTechAllocateClose"
      :close-on-click-modal="false"
    >
      <div style="margin-bottom: 15px; font-size: 15px; color: #333;">
        <span>项目名称：</span>
        <span style="font-weight: 700;">{{ techAllocateProjectName }}</span>
      </div>
      <div class="oneRow" style="display: flex; align-items: center;">
        <div style="width: 140px; flex-shrink: 0; font-size: 14px; color: #606266;">选择技术人员</div>
        <div style="flex: 1;">
          <select-transfer
            :selectedId="techAllocatePersonnelIds"
            style="width: 100%;"
            @my-transfer-change="handleTechAllocateChange"
          ></select-transfer>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleTechAllocateClose">取消</el-button>
        <el-button type="primary" @click="handleTechAllocateSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import CheckStep from '../../components/CheckStep'
import OneSelected from '../../components/OneSelected'
import SelectTransfer from '../../components/selectTransfer'
export default {
  name: 'projectIndex',
  data() {
    return {
      searchproject_type_id: '',
      searchDate1: '',
      searchDate2: '',
      SearchPeopleId: '',
      projectTypeList: [],
      member_id: '',
      token: '',
      project_status: '',
      company_id: '',
      cache_department_id: '',
      dialogVisible: false,
      hoverId: '',
      activeDorpList: '',
      projectActive: '1',
      searchInfo: '',
      currentPage: 1,
      Total: 0,
      pageSize: 10,
      projectLog: {
        reg: {},
        scene: {},
        audit: {},
        seal: {},
        out: {},
        file: {},
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.searchDate2) {
            return (
              time.getTime() > new Date(this.searchDate2).getTime() ||
              time.getTime() > Date.now() - 8.64e6
            )
          } else {
            return time.getTime() > Date.now() - 8.64e6
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.searchDate1) {
            return (
              time.getTime() <
                new Date(this.searchDate1).getTime() - 86400000 ||
              time.getTime() > Date.now() - 8.64e6
            )
          } else {
            return time.getTime() > Date.now() - 8.64e6
          }
        },
      },
      projectList: [],
      PorjectType: '',
      projectBstatus: '',
      listInfo1: [],
      listInfo2: [],
      dialogVisibleStep: false,
      ckeckProjectId: '',
      // 技术人员分配弹窗
      techAllocateDialogVisible: false,
      techAllocateProjectId: '',
      techAllocateProjectName: '',
      techAllocatePersonnelIds: [],
    }
  },
  components: {
    CheckStep,
    OneSelected,
    SelectTransfer,
  },
  methods: {
    guidangClick(item) {
      this.$router.push({
        path: '/project/details/task',
        query: {
          project_id: item.project_id,
          project_status: item.project_status,
          project_name: item.project_name,
          project_code: item.project_code,
          company_name: item.company_name,
          isEdit: '1',
          // 存档
          is_over: '1',
        },
      })
    },
    handleSearchPeopleChange(data) {
      console.log('组件传过来的搜索', data)
      this.SearchPeopleId = data
    },
    async handleCollect(id, val) {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      param.append('project_id', id)
      param.append('status', val)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/set_attention',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.getProjectTypeList()
    },
    // *删除项目
    async handleRemoveProject(id) {
      const isDelete = await this.$confirm('是否删除项目', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('cache_department_id', this.cache_department_id)
        param.append('project_id', id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/project_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getProjectTypeList()
      }
    },
    handleSearch() {
      this.currentPage = 1
      this.getProjectTypeList()
    },
    // *获取项目
    async getProjectTypeList() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
      }
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      param.append('project_status', this.project_status)
      param.append('search', this.searchInfo)
      param.append('p', this.currentPage)
      param.append('p_count', this.pageSize)
      param.append('type', this.PorjectType)
      param.append('project_bstatus', this.projectBstatus)
      param.append('permit_type', this.projectBstatus)
      param.append('create_member', this.SearchPeopleId)
      param.append('start_time', this.searchDate1)
      param.append('end_time', this.searchDate2)
      param.append('project_type_id', this.searchproject_type_id)
      // permit_type: this.showFenId,
      // 			evaluator_member: this.insiderId
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/project_list',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.projectList = res.datas.listInfo
      this.Total = parseInt(res.datas.count)
      console.log('项目列表', this.projectList)
    },
    // 获取项目类型
    async getProjectTypeListForSearch() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/project_type',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.projectTypeList = res.datas.listInfo
      console.log('项目类型', this.projectTypeList)
    },
    // 点击新增
    goAddProject() {
      this.$router.push({
        type: 'query',
        path: '/project/add',
        query: {
          type: 'addPage',
        },
      })
    },
    // *点击查看进度
    async checkStepClick(id) {
      this.$refs.checkStep.checkStep(id)
    },
    showDetails(item) {
      this.$router.push({
        path: '/project/details/task',
        query: {
          project_id: item.project_id,
          project_status: item.project_status,
          project_name: item.project_name,
          project_code: item.project_code,
          company_name: item.company_name,
          isEdit: '1',
          // 只是申请此项目编号
          demand_type: item.demand_type,
        },
      })
    },
    activeDorpListClick(val) {
      if (this.activeDorpList === val) return (this.activeDorpList = '')
      this.listInfo1 = []
      this.listInfo2 = []
      console.log(val)
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      param.append('project_id', val)
      this.$axios({
        method: 'post',
        url: '/api/Project/get_project_member',
        data: param,
      }).then((res) => {
        // console.log('res', res.data.datas)
        this.listInfo1 = res.data.datas.list1
        this.listInfo2 = res.data.datas.list2
        this.activeDorpList = val
      })
    },
    // 点击「技术人员分配」按钮
    handleTechAllocateClick(item) {
      this.techAllocateProjectId = item.project_id
      this.techAllocateProjectName = item.project_name || item.company_name || ''
      this.techAllocatePersonnelIds = []
      this.techAllocateDialogVisible = true
      this.getTechAllocateDetail(item.project_id)
    },
    // 获取技术人员分配详情（回显已选人员）
    async getTechAllocateDetail(projectId) {
      if (!projectId) return
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      param.append('project_id', projectId)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/people_allocate_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      const raw = res.datas && res.datas.allocate_personnel
      this.techAllocatePersonnelIds = this.normalizeAllocatePersonnel(raw)
      console.log('技术人员分配详情', this.techAllocatePersonnelIds)
    },
    // 把 allocate_personnel 统一解析成 id 字符串数组
    normalizeAllocatePersonnel(value) {
      if (Array.isArray(value)) {
        return value
          .map((item) => {
            if (item && typeof item === 'object') {
              return item.id || item.member_id || item.value || ''
            }
            return item
          })
          .map((item) => String(item))
          .filter(Boolean)
      }
      if (value === null || value === undefined || value === '') {
        return []
      }
      return String(value)
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean)
    },
    // 技术人员选择变化
    handleTechAllocateChange(data) {
      const selectedList = Array.isArray(data) ? data : []
      this.techAllocatePersonnelIds = selectedList
        .map((item) => item.id)
        .filter(Boolean)
        .map((item) => String(item))
    },
    // 保存技术人员分配
    async handleTechAllocateSubmit() {
      if (!this.techAllocateProjectId) {
        return this.$message.warning('项目信息缺失，请重新选择')
      }
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      param.append('project_id', this.techAllocateProjectId)
      param.append(
        'allocate_personnel',
        this.techAllocatePersonnelIds.join(',')
      )
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/people_allocate',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg || '分配成功')
      this.techAllocateDialogVisible = false
      this.techAllocateProjectId = ''
      this.techAllocateProjectName = ''
      this.techAllocatePersonnelIds = []
    },
    handleTechAllocateClose() {
      this.techAllocateDialogVisible = false
      this.techAllocateProjectId = ''
      this.techAllocateProjectName = ''
      this.techAllocatePersonnelIds = []
    },
    handleClick(tab, event) {
      console.log(tab, event)
      if (tab.name == '3' || tab.name == '4' || tab.name == '5') {
        this.$nextTick(() => {
          let a = document.getElementsByClassName('el-tabs__active-bar')
          a[0].style.marginLeft = '50px'
        })
      } else {
        this.$nextTick(() => {
          let a = document.getElementsByClassName('el-tabs__active-bar')
          a[0].style.marginLeft = '30px'
        })
      }
      if (tab.name == '1') {
        this.currentPage = 1
        this.projectBstatus = ''
        this.getProjectTypeList()
      }
      if (tab.name == '2') {
        this.currentPage = 1
        this.projectBstatus = '1'
        this.getProjectTypeList()
      }
      if (tab.name == '3') {
        this.currentPage = 1
        this.projectBstatus = '2'
        this.getProjectTypeList()
      }
      if (tab.name == '4') {
        this.currentPage = 1
        this.projectBstatus = '3'
        this.getProjectTypeList()
      }
      if (tab.name == '5') {
        this.currentPage = 1
        this.projectBstatus = '4'
        this.getProjectTypeList()
      }
      if (tab.name == '6') {
        this.currentPage = 1
        this.projectBstatus = '5'
        this.getProjectTypeList()
      }
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.currentPage = 1
      this.getProjectTypeList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getProjectTypeList()
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    handleClosed() {
      this.ckeckProjectId = ''
    },
    handleStepClose(done) {
      this.dialogVisibleStep = false
    },
    handleStepClose() {
      this.ckeckProjectId = ''
    },
  },
  // activated() {
  //   this.getProjectTypeList()
  //   console.log('activatedactivatedactivatedactivatedactivated')
  // },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    if (this.$route.query.type) {
      if (this.$route.query.type == 'guidang') {
        return (this.projectBstatus = '6')
      }
      this.PorjectType = this.$route.query.type
    }
    this.getProjectTypeListForSearch()
    this.getProjectTypeList()
  },
  watch: {
    $route: {
      handler(val, oldVal) {
        if (
          val.path == '/project/index'
          // val.path == '/project/attention' ||
          // val.path == '/project/save' ||
          // val.path == '/project/classify'
        ) {
          if (val.query.type) {
            this.PorjectType = val.query.type
          } else {
            this.PorjectType = ''
          }
          this.getProjectTypeList()
        }
      },

      deep: true,
    },
  },
}
</script>
<style lang="less" scoped>
#projectIndex {
  box-sizing: border-box;
  padding: 30px;
  height: 100%;
  .formBody {
    background-color: #fff;
    box-sizing: border-box;
    border-radius: 10px;
    box-shadow: 1px 5px 9px 0px rgba(3, 70, 126, 0.14);
    width: 100%;
    height: 100%;
    background-color: #fff;
    box-sizing: border-box;
    padding: 20px 30px;
    // 搜索行
    .searchRow {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 20px;
      /deep/.tableSearch {
        width: 450px;
        // (deep)
        .el-input__inner {
          padding-left: 25px;
          // 搜索框居中
          height: 45px;
          border-radius: 24px;
          font-size: 16px;
          border: none;
          background-color: #f4f5f6;
          color: #333;
          &::placeholder {
            color: #333;
          }

          &::-webkit-input-placeholder {
            /* WebKit browsers 适配谷歌 */
            color: #333;
          }

          &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 适配火狐 */
            color: #333;
          }
        }
      }
      .btnCol {
        display: flex;
        align-items: center;
        /deep/.el-button {
          font-size: 18px;
          font-weight: normal;
          border: none;
          width: 130px;
          height: 45px;
          background: #f4a029;
          color: #fff;
          border-radius: 24px;
          padding: 0;
          margin-left: 30px;
        }
        img {
          cursor: pointer;
          margin-left: 30px;
        }
      }
    }
    .knowledgeHisTable {
      width: 100%;
      // height: 68vh;
      height: 100%;

      .table__body {
        box-sizing: border-box;
        height: calc(100% - 60px);
        width: 100%;
        overflow-y: auto;
        padding: 0 2px;
        // li
        .tableBodyItem {
          cursor: pointer;
          position: relative;
          box-sizing: border-box;
          padding: 20px 40px;
          border-bottom: 1px solid #ebebeb;
          width: 100%;
          display: flex;
          justify-content: space-between;
          .colseIcon {
            position: absolute;
            right: 10px;
            top: 10px;
            color: #666;
            font-size: 18px;
            display: none;
          }
          .starIcon {
            display: none;
          }
          .itemleft {
            font-size: 16px;
            color: #999999;
            .projectItemTitle {
              display: flex;
              align-items: center;
              font-size: 20px;
              color: #333;
              font-weight: 700;
            }
          }
          .itemRight {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            /deep/.checkBtn {
              margin-top: 20px;
              color: #0099ff;
              border-color: #0099ff;
              font-weight: normal;
              padding: 0 22px;
              height: 32px;
            }
            /deep/ .checkBtn1 {
              margin-right: 15px;
              color: rgb(245, 95, 95);
              border-color: rgb(245, 95, 95);
            }
          }
          // 知识库-列表创建人下拉框
          .moreDrop {
            position: relative;
            .dropBody {
              position: absolute;
              left: -340px;
              top: -10px;
              z-index: 99;
              background: rgba(255, 255, 255, 1);
              box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.11);
              box-sizing: border-box;
              padding: 20px;
              padding-bottom: 0;
              width: 320px;
              // height: 360px;
              border-radius: 5px;
              .creatPeople {
                font-size: 16px;
                font-weight: 400;
                color: #128bf1;
                display: flex;
                align-items: center;
              }
              .headerBox {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                box-sizing: border-box;
                padding: 0 10px;
                padding-top: 20px;
                .ceatPeopleInfo {
                  width: 50%;
                  display: flex;
                  padding-bottom: 20px;
                  align-items: center;
                  img {
                    width: 46px;
                    height: 46px;
                    border-radius: 23px;
                  }
                  img:nth-child(odd) {
                    margin-left: 0;
                  }
                  span {
                    display: inline-block;
                    width: 70px;
                    overflow: hidden; /*超出部分隐藏*/
                    white-space: nowrap; /*不换行*/
                    text-overflow: ellipsis; /*超出部分文字以...显示*/
                    font-size: 14px;
                    color: #666666;
                    margin-left: 11px;
                  }
                }
              }
              .creatPeople::before {
                content: '';
                display: block;
                width: 2px;
                height: 14px;
                background-color: #40a0f2;
                margin-right: 10px;
              }
              .border-up-empty::after {
                content: '';
                position: absolute;
                left: 310px;
                top: 20px;
                width: 0;
                height: 0px;
                border-style: solid;
                border-width: 10px;
                border-color: #fff #fff transparent transparent;
                transform: rotate(-315deg);
                box-shadow: 3px -3px 3px rgba(0, 0, 0, 0.11);
              }
            }
          }
          .headerLogo {
            width: 46px;
            height: 46px;
            border-radius: 50%;
            margin-left: 10px;
          }
        }
        .tableBodyItem:hover {
          box-shadow: 0px 0px 9px 0px rgba(3, 70, 126, 0.14);
          .projectItemTitle {
            color: #128bf1;
          }
        }
        .tableBodyItem:hover .starIcon {
          display: block !important;
        }
        .tableBodyItem:hover .colseIcon {
          display: block !important;
        }
      }
      // 分页行
      .pageRow {
        height: 20px;
        box-sizing: border-box;
        padding-top: 10px;
        margin-top: 10px;
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: flex-end;
        /deep/.el-pagination .el-select .el-input .el-input__inner {
          font-size: 14px;
        }
        /deep/.el-pagination button,
        /deep/.el-pagination span:not([class*='suffix']) {
          font-size: 14px;
        }
      }
    }
  }
}
#projectIndex {
  // *修改tabs样式
  /deep/.el-tabs__active-bar {
    width: 60px !important;
    margin-left: 30px;
  }
  /deep/.el-tabs {
    width: 100%;
    height: calc(100% - 68px);
    .el-tabs__header {
      width: 100%;
      margin-bottom: 20px;
      .el-tabs__nav-wrap {
        width: 100%;
        .el-tabs__nav-scroll {
          width: 100%;
          .el-tabs__nav {
            box-sizing: border-box;
            padding-left: 40px;
            width: 100%;
          }
        }
      }
    }
    .el-tabs__content {
      height: calc(100% - 80px);
      .el-tab-pane {
        height: 100%;
      }
    }
  }
  /deep/.el-tabs__item {
    height: 60px;
    text-align: center;
    font-size: 20px;
    color: #666;
    font-weight: 700;
    padding-right: 100px;
    // width: 17%;
  }
  /deep/.el-tabs__item.is-active {
    color: #409eff !important;
  }
  /deep/.el-tabs__item:hover {
    color: #409eff !important;
  }
  /deep/.el-tabs__nav-wrap::after {
    color: #999999;
  }
  // *修改tabs样式
}
// 修改时间线样式
/deep/ .projectTime {
  margin-left: 100px;
  .el-timeline-item__content {
    padding: 20px 0 0px;
  }
  /deep/.el-timeline-item__timestamp.is-top {
    font-size: 18px;
    color: #128bf1;
    font-weight: 700;
    padding-top: 0;
  }
  .stepItem {
    display: flex;
    box-sizing: border-box;
    padding-left: 50px;
    margin-bottom: 15px;
    p {
      font-size: 16px;
    }
  }

  // 半透明圆环
  .eltimelinefocus {
    // 线
    .el-timeline-item__tail {
      border-color: #40a0f2;
    }
    .el-timeline-item__node {
      // border: 3px solid hsla(0, 0%, 90%, 0.8);
      border: 3px solid #cbe0ff;
      background-clip: content-box;
      background: rgba(78, 151, 255, 1);
    }
    .el-timeline-item__node--normal {
      left: -3px;
      top: -3px;
      width: 11px;
      height: 11px;
    }
  }
  // 半透明圆环
  .eltimelineNofocus {
    // 线
    .el-timeline-item__tail {
      border-left: 2px dashed #e3e3e3;
    }
    .el-timeline-item__node {
      // border: 3px solid hsla(0, 0%, 90%, 0.8);
      border: 3px solid #efefef;
      background-clip: content-box;
      background: #ddd;
    }
    .el-timeline-item__node--normal {
      left: -3px;
      top: -3px;
      width: 11px;
      height: 11px;
    }
  }
}
// 修改弹窗样式
// dialog弹窗
/deep/.el-dialog {
  border-radius: 10px;
  .el-dialog__header {
    border-radius: 10px 10px 0 0;
    background-color: #f4f5f6;
    font-size: 20px;
    color: #333;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 40px;
  }
}
.stepDia {
  /deep/.el-dialog {
    min-width: 750px;
    margin-top: 10vh !important;
    margin-bottom: 0;
    .el-dialog__body {
      padding: 20px 20px;
      padding-bottom: 10px;
    }
  }
}
.table__body::-webkit-scrollbar {
  width: 5px !important;
}
.table__body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
.table__body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}
/deep/.diaHistoryBox {
  height: 70vh;
  overflow-y: auto;
  .projectTime {
    padding: 10px 0;
  }
}
// 修改人员选择(搜索栏的人员选择)
/deep/#MyTransfer {
  width: 40%;
  .filter-dash-btn {
    width: 100%;
    border: none;
    border-radius: 24px;
    background-color: #f4f5f6;
    height: 45px;
    font-size: 16px;
    color: #333;
    .filter-tips-default {
      color: #333;
      width: 100%;
      padding-left: 25px;
    }
  }
  .checked-app-item {
    margin-left: 10px;
    border: none;
    background-color: #f4f5f6;
  }
}
.projectListOver {
  display: block;
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
// 去掉日期选择器图标
/deep/ .el-input__prefix {
  .el-icon-date {
    display: none;
  }
}
</style>
